export const cloudverwaltung = {
  headerTitle: 'Microsoft-365',
  route: 'cloud',
  pageTitle: 'Microsoft 365',
  related: [
    { route: 'benutzerverwaltung/lehrerinnen', menuTitle: 'Lehrer*innen verwalten' },
    { route: 'benutzerverwaltung/schuelerinnen', menuTitle: 'Schüler*innen verwalten' },
    { route: 'moodle', menuTitle: 'Moodle verwalten' },
  ],
  cards: [
    {
      route: 'domains',
      icon: 'fa-microsoft',
      endpoint: '/api/cloud/domains',
      tag: 'paedml-card-domain',
      category: 'Microsoft-365',
      menuTitle: 'Externe Domäne',
      pageTitle: 'paed.ML - Externe Domäne',
      name: 'domain',
      contentTitle: 'Externe Domäne',
      prefix: 'clouddomain',
      suffix: undefined,
      custom: {
        variant: 'clouddomain'
      },
      table: {
        columns: [
          { title: 'Externe Domäne', name: 'domain', col: 0 }
        ],
        data: {
          dataSrc: ''
        },
        custom: {
          pageLength: 10
        }
      }
    },

    {
      route: 'lehrerinnen',
      icon: 'fa-microsoft',
      endpoint: '/api/cloud/teachers',
      tag: 'paedml-card-cloud',
      category: 'Microsoft-365',
      menuTitle: 'Lehrer*innen',
      pageTitle: 'paed.ML - Microsoft-365-Lehrer*innen',
      name: 'cloudlul',
      contentTitle: 'Lehrer*innen',
      prefix: 'cloudlul',
      suffix: undefined,
      custom: {
        variant: 'teacher'
      },
      table: {
        columns: [
          { title: 'ID', name: 'id', col: 0, visible: false, searchable: false, printable: false, exportable: false },
          { title: 'Benutzername', name: 'userName', col: 1 },
          { title: 'Name', name: 'surname', col: 2 },
          { title: 'Vorname', name: 'givenName', col: 3 },
          { title: 'Basis-Schule', name: 'mainSchoolType', col: 4 },
          { title: 'Schule(n)', name: 'schoolTypes', separator: ', ', col: 5, filter: 'Schule', filterType: 'regex' },
          { title: 'MS 365 Domain', name: 'domain', col: 6 },
          { title: 'MS 365 aktiv', name: 'isO365Enabled', col: 7, filter: 'JaNein', filtertitle:"MS 365 aktiv", filterType: 'smart' },
        ],
        data: {
          dataSrc: ''
        },
        custom: {
          pageLength: 10,
          select: {
            style: 'multi+shift'
          }
        }
      }
    },

    {
      route: 'schuelerinnen',
      icon: 'fa-microsoft',
      endpoint: '/api/cloud/students',
      preHooks: {
        list: 'cloud_schueler_list_preHook'
      },
      tag: 'paedml-card-cloud',
      category: 'Microsoft-365',
      menuTitle: 'Schüler*innen',
      pageTitle: 'paed.ML - Cloud-Schüler*innen',
      name: 'cloudsus',
      contentTitle: 'Schüler*innen',
      prefix: 'cloudsus',
      suffix: undefined,
      custom: {
        variant: 'student'
      },
      table: {
        columns: [
          { title: 'ID', name: 'id', col: 0, visible: false, searchable: false, printable: false, exportable: false },
          { title: 'Benutzername', name: 'userName', col: 1 },
          { title: 'Name', name: 'surname', col: 2 },
          { title: 'Vorname', name: 'givenName', col: 3 },
          { title: 'Schule', name: 'mainSchoolType', col: 4, filter: 'Schule', filterType: 'regex' },
          { title: 'Klasse', name: 'schoolClass', col: 5, filter: 'Klasse', dynamicfilter: 'klassen', filterType:'regex' },
          { title: 'Schuljahr', name: 'schoolYear', col: 6, searchable: false },
          { title: 'MS 365 Domain', name: 'domain', col: 7 },
          { title: 'MS 365 aktiv', name: 'isO365Enabled', col: 8, filter: 'JaNein', filtertitle:"MS 365 aktiv" },
        ],
        data: {
          dataSrc: ''
        },
        custom: {
          pageLength: 10,
          select: {
            style: 'multi+shift'
          }
        }
      }
    },

  ]
}